import { Box } from '@common/components';

const TeamDivider = ({ mt }) =>
(
    <Box h="1px" bgColor="#EAECF0" mb="25px" mt={mt} />
);

export default TeamDivider;